// Import all icons as a single object and export as default for robust dynamic access
import * as AllIcons from "@ant-design/icons";
export default AllIcons;
